import store from '@/store';
import { allMunicipalityOptions } from '@/services/allMunicipalityOptions';
import { isValue, isNumeric, isUrl, isEmail,  unicodeString, isFloat, required, isValidPostalcode, isValidLatitude, isValidLongitude } from '@/services/validation'

export function getMunicipalities() {
  return allMunicipalityOptions.sort((a, b) => a.text.localeCompare(b.text))
}

export function getProvinces() {
  return [
    { value: 'Drenthe', text: 'Drenthe' },
    { value: 'Flevoland', text: 'Flevoland' },
    { value: 'Friesland', text: 'Friesland' },
    { value: 'Gelderland', text: 'Gelderland' },
    { value: 'Groningen', text: 'Groningen' },
    { value: 'Limburg', text: 'Limburg' },
    { value: 'Noord-Brabant', text: 'Noord-Brabant' },
    { value: 'Noord-Holland', text: 'Noord-Holland' },
    { value: 'Overijssel', text: 'Overijssel' },
    { value: 'Utrecht', text: 'Utrecht' },
    { value: 'Zeeland', text: 'Zeeland' },
    { value: 'Zuid-Holland', text: 'Zuid-Holland' }
  ];
}

export function getContractors() {
  const contractors = store.getters['tenant/getEnabledContractors'];
  return contractors.map(contractor => ({
    value: contractor.uuid,
    text: contractor.label
  }));
}

export function validationType(type) {
  switch (type) {
    case 'required':
      return (value) =>  required(value)
    case 'isNumeric':
      return (value) =>  !isValue(value) || isNumeric(value)
    case 'isUrl':
      return (value) =>  !isValue(value) || isUrl(value)
    case 'isEmail':
      return (value) =>  !isValue(value) || isEmail(value)
    case 'isFloat':
      return (value) =>  !isValue(value) || isFloat(value)
    case 'unicodeString':
      return (value) =>  !isValue(value) || unicodeString(value)
    case 'isValidPostalcode':
      return (value) =>  !isValue(value) || isValidPostalcode(value.trim())
    case 'isValidLatitude':
      return (value) =>  !isValue(value) || isValidLatitude(value)
    case 'isValidLongitude':
      return (value) =>  !isValue(value) || isValidLongitude(value)

    default:
      return true
  }
}

export function setValidations(form) {
  for (let part of form) {
    if (part.validation) {
      Object.keys(part.validation).forEach(key => {
        const validationArray = part.validation[key];
        if (Array.isArray(validationArray)) {
          const validationObject = {};
          validationArray.forEach(validation => {
            validationObject[validation] = validationType(validation);
          });
          part.validation[key] = validationObject;
        }
      })
    }
  }
}

export function getPids() {
  const pids = store.getters['tenant/getPIDs'];
  return pids.filter(pid => pid.enabled && !pid.deleted_at).map(pid => ({
    value: pid.uuid,
    text: pid.label
  }));
}
